export const AI_BACKEND_ERROR_TYPES = <const>{
  QUESTION_NOT_FOUND_ERROR: 'QuestionNotFoundError'
};
